import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useTrackPath = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("lastPath", location.pathname);
  }, [location.pathname]);
};
